export default {
    api: 'API',
    context: 'Контекстная реклама',
    mailing: 'Рассылки',
    referral: 'Партнерская сеть',
    seo: 'SEO',
    social: 'Соц. сети'
};
